import { assetUrl } from '../assets/asset-manifest.js';

export interface LoadingStateProps {
  label?: string;
}

/**
 * An accessible busy indicator (`role="status"`, `aria-live="polite"` — APP_SPEC §36).
 * The rune mark rotates and the glow pulses; both stop under
 * `prefers-reduced-motion` via the global rule in `styles/index.css`.
 */
export function LoadingState({ label = 'Loading…' }: LoadingStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-32 flex-col items-center justify-center gap-3 rounded-lg border border-border bg-surfaceElevated p-6 font-editorial text-textSecondary"
    >
      <span
        aria-hidden="true"
        className="relative inline-flex h-10 w-10 items-center justify-center"
      >
        <img
          src={assetUrl('loadingGlow')}
          alt=""
          width={512}
          height={512}
          className="absolute inset-0 h-full w-full animate-pulse opacity-70"
        />
        <img
          src={assetUrl('loadingRune')}
          alt=""
          width={64}
          height={64}
          className="relative h-7 w-7 motion-safe:animate-spin"
          style={{ animationDuration: '2.4s' }}
        />
      </span>
      <span>{label}</span>
    </div>
  );
}
